/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type SignatureRequestSenderV1Dto = {
  type: SignatureRequestSenderV1Dto.type;
};
export namespace SignatureRequestSenderV1Dto {
  export enum type {
    CUSTOM = 'custom',
    ORGANIZATION = 'organization',
    USER = 'user',
    WORKSPACE = 'workspace',
  }
}
